import { debugModeStore } from "../stores/debugModeStore.ts";

export const useDebugMode = () => {
  const { isDebugModeOn } = debugModeStore.useState();
  return isDebugModeOn;
};
